(function () {
  var theme = window.theme || {};
  var config = theme.subscriptionCartGuard || {};

  if (!config.enabled) return;

  var isRemoving = false;
  var cleanupTimer = null;
  var DISABLED_BUTTON_SELECTOR = '.subscription-join__link, .subscription-intro__button';

  function preventDisabledClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function disableSubscriptionButtons() {
    document.querySelectorAll(DISABLED_BUTTON_SELECTOR).forEach(function (button) {
      if (!button) return;

      button.classList.add('is-disabled');
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('data-subscription-guard-disabled', 'true');

      if ('disabled' in button) {
        button.disabled = true;
      }

      if (button.tagName === 'A') {
        if (button.href && !button.dataset.subscriptionGuardHref) {
          button.dataset.subscriptionGuardHref = button.getAttribute('href') || '';
        }

        button.removeAttribute('href');
        button.setAttribute('role', 'button');
        button.setAttribute('tabindex', '-1');
      }

      if (button.dataset.subscriptionGuardClickBound !== 'true') {
        button.addEventListener('click', preventDisabledClick, true);
        button.dataset.subscriptionGuardClickBound = 'true';
      }
    });
  }

  function isSubscriptionItem(item) {
    if (!item) return false;

    if (config.productId && Number(item.product_id) === Number(config.productId)) {
      return true;
    }

    return Boolean(config.productHandle && item.handle === config.productHandle);
  }

  function getCart() {
    if (theme.cart && typeof theme.cart.getCart === 'function') {
      return theme.cart.getCart();
    }

    return fetch((theme.routes && theme.routes.cart) || '/cart.js', {
      credentials: 'same-origin',
      method: 'GET'
    }).then(function (response) {
      return response.json();
    });
  }

  function changeItem(key, quantity) {
    if (theme.cart && typeof theme.cart.changeItem === 'function') {
      return theme.cart.changeItem(key, quantity).then(function (cart) {
        return typeof cart === 'string' ? JSON.parse(cart) : cart;
      });
    }

    return fetch(((theme.routes && theme.routes.cartChange) || '/cart/change.js') + '?t=' + Date.now(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    }).then(function (response) {
      return response.json();
    });
  }

  async function removeSubscriptionProduct() {
    if (!config.productId && !config.productHandle) return;
    if (isRemoving) return;

    isRemoving = true;

    try {
      var cart = await getCart();
      var subscriptionItems = (cart.items || []).filter(isSubscriptionItem);
      var updatedCart = cart;

      if (!subscriptionItems.length) return;

      for (var i = 0; i < subscriptionItems.length; i += 1) {
        updatedCart = await changeItem(subscriptionItems[i].key, 0);
      }

      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: {
            cart: updatedCart
          }
        })
      );
    } catch (error) {
      console.error('Unable to remove subscription product from cart.', error);
    } finally {
      isRemoving = false;
    }
  }

  function scheduleCleanup() {
    window.clearTimeout(cleanupTimer);
    cleanupTimer = window.setTimeout(removeSubscriptionProduct, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        disableSubscriptionButtons();
        scheduleCleanup();
      },
      { once: true }
    );
  } else {
    disableSubscriptionButtons();
    scheduleCleanup();
  }

  document.addEventListener('shopify:section:load', disableSubscriptionButtons);
  document.addEventListener('ajaxProduct:added', scheduleCleanup);
  document.addEventListener('cart:updated', function () {
    if (!isRemoving) scheduleCleanup();
  });
})();
